import loadable from "utils/loadable";

export const HalamanArticle = loadable(() => import("./index"));
